import React, { useEffect, useMemo, useState } from 'react'
import { Title } from '../../../../stories/Title/Title';
import Close from "../../../../images/Close.svg"
import useAssetTableJson from '../../../../json/useAssetTableJson';
import
{
  GridColDef,
  GridAlignment,
  GridColumnVisibilityModel,
  GridValidRowModel,
  GridColumnHeaderParams
} from "@mui/x-data-grid-pro";
import { msgType, TableHeaderProps } from '../../../../utils/types';
import { AttendanceTypes, Operation } from '../../../../utils/Enum.types';
import { StyledDatagrid } from '../../../../styles/DatagridStyles';
import { TABLE_ROW_HEIGHT } from '../../../../styles/Variables';
import { ColumnVisibilityFor } from '../../../../utils/Enum.Datagrid';
import { Button } from '../../../../stories/Button/Button';
import { EmpMaster } from '../users/queries/types';
import { number } from 'yup';
import { useMutation } from '@apollo/client';
import { AddMomAttResult, AddMomAttVars } from './queries/types';
import { AddMomAtt } from './queries/mutations';
import { emptyMessage } from '../../../../utils/constants';
import useUrlParams from '../../../../customHooks/useUrlParams';
import useLoggedInUserDetails from '../../../../customHooks/useLoggedInUserDetails';
import MessageModal from '../../../../customComponents/MessageModal';
import { GetMomAtt, GetMomAttCount } from './queries/query';


interface Props
{
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
  empDetails: EmpMaster[];
}
const AttendedDetails = ( { setModalFlag, empDetails }: Props ) =>
{
  const { MinutesOfMeeting } = useAssetTableJson();
  const [ columnVisibilityModel, setColumnVisibilityModel ] =
    useState<GridColumnVisibilityModel>( {} );
  const { customer_id, momID } = useUrlParams();

  const { user_details } = useLoggedInUserDetails();

  const [ message, setMessage ] = useState<msgType>( emptyMessage );


  const [ AddAttendance, { loading: AddAttendanceLoading } ] = useMutation<AddMomAttResult, AddMomAttVars>( AddMomAtt, {
    onError: ( e ) =>
    {
      setMessage( {
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      } );
    },
  } );

  const dynamicHeaders: TableHeaderProps[] = MinutesOfMeeting.Attended.filter( ( header ) => header.field !== "status" ).map(
    ( header ) => ( {
      headerName: header.headerName,
      field: header.field,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex,
      hideable: header.hideable,
      renderCell: ( params ) =>
      {
        if ( header.field === "status" )
        {
          return (
            <>
              <span className={params.row.status === AttendanceTypes.Present ? "font-green" : "font-red"}> {params.row.status}</span>
            </>
          );
        } else return params.value;
      },
    } )
  );

  const columns = [ ...dynamicHeaders ];
  const rows: GridValidRowModel[] = useMemo( () =>
  {
    return empDetails ? empDetails.map( ( item, index ) => ( {
      id: index + 1,
      employee_name: item.name,
      user_type: item.empType,
    } ) ) : [];
  }, [ empDetails ] )





  useEffect( () =>
  {
    const savedModel = localStorage.getItem(
      ColumnVisibilityFor.MOM_ATTENDED_DETAILS
    );
    if ( savedModel )
    {
      setColumnVisibilityModel( JSON.parse( savedModel ) );
    }
  }, [] );

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel
  ) =>
  {
    setColumnVisibilityModel( newModel );
    localStorage.setItem(
      ColumnVisibilityFor.MOM_ATTENDED_DETAILS,
      JSON.stringify( newModel )
    );
  };


  const handleSubmit = () =>
  {
    if ( customer_id && momID )
    {
      AddAttendance( {
        variables: {
          customerID: customer_id!,
          user_details,
          input: {
            momID,
            empIds: empDetails.map( ( item ) => item.id ),
            invitees: "",
            projectID: 0,
          }
        },
        refetchQueries: [
          {
            query: GetMomAttCount,
            variables: {
              customerID: customer_id,
              momID,
              projectID: 0,
              latest: true,
            },
          },
          {
            query: GetMomAtt,
            variables: {
              customerID: customer_id,
              momID,
              projectID: 0,
              latest: true,
            },
          },
          {
            query: GetMomAttCount,
            variables: {
              customerID: customer_id,
              momID,
              projectID: -1,
              latest: true,
            },
          },
          {
            query: GetMomAtt,
            variables: {
              customerID: customer_id,
              momID,
              projectID: -1,
              latest: true,
            },
          }
        ]
      } ).then( ( { data } ) =>
      {
        if ( data && data.AddMomAtt )
        {
          setMessage( {
            flag: true,
            message: "Attendance added successfully",
            operation: Operation.CREATE,
          } );
        }
      } );
    }
  }

  return (
    <div className='attended-details'>
      <div className="attended-details__title">
        <Title>Attended Details</Title>
        <img src={Close} alt="" onClick={() => setModalFlag( false )} />
      </div>
      <div className="attended-details__tableblock">
        <StyledDatagrid
          columns={columns}
          rows={rows}
          rowHeight={TABLE_ROW_HEIGHT}
          disableRowSelectionOnClick
          hideFooter
          columnVisibilityModel={columnVisibilityModel}
          onColumnVisibilityModelChange={handleColumnVisibilityChange}
        />
      </div>
      <Button mode='save' onClick={handleSubmit} loading={AddAttendanceLoading} />
      <Button mode='cancel' onClick={() => setModalFlag( false )} loading={AddAttendanceLoading} />
      <MessageModal
        handleClose={() =>
        {
          setMessage( emptyMessage )
        }}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}

      />
    </div>
  )
}

export default AttendedDetails;
